var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono Youtube"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 12.1876,
    cy: 12.1876,
    r: 12.1876,
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2665 7.59146C17.8259 7.74495 18.2664 8.19722 18.4159 8.77156C18.6876 9.81249 18.6876 11.9844 18.6876 11.9844C18.6876 11.9844 18.6876 14.1562 18.4159 15.1972C18.2664 15.7716 17.8259 16.2238 17.2665 16.3774C16.2528 16.6563 12.1875 16.6563 12.1875 16.6563C12.1875 16.6563 8.12228 16.6563 7.1085 16.3774C6.54912 16.2238 6.1086 15.7716 5.9591 15.1972C5.6875 14.1562 5.6875 11.9844 5.6875 11.9844C5.6875 11.9844 5.6875 9.81249 5.9591 8.77156C6.1086 8.19722 6.54912 7.74495 7.1085 7.59146C8.12228 7.3125 12.1875 7.3125 12.1875 7.3125C12.1875 7.3125 16.2528 7.3125 17.2665 7.59146ZM10.9688 10.1562V14.2187L14.2188 12.1876L10.9688 10.1562Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoYoutube);
export default __webpack_public_path__ + "static/media/icono-youtube.2f7b5be315c5ab70b9022c941b16b2e7.svg";
export { ForwardRef as ReactComponent };